<!-- 电影院选座 cinema-seat -->

<template>
  <div class="root-wrap fx-column">
    <div class="header-wrap">
      <!-- 这里将影院名称可以设置为html title-->
    </div>

    <div class="body-wrap fx-fill">
      <div class="fill-box">
        <div class="seat_legend-wrap">
          <div class="seat_legend fx-row fx-middle">
            <div class="seat_legend-item fx-center fx-row">
              <van-image :src="require('@/assets/images/seat/seat_sold.png')" fit="contain" height="20" />
              <span>已售</span>
            </div>
            <div class="seat_legend-item fx-center fx-row">
              <van-image :src="require('@/assets/images/seat/seat_selectable.png')" fit="contain" height="20" />
              <span>可选</span>
            </div>
            <div class="seat_legend-item fx-center fx-row" v-for="key, index in areaMap.keys()" :key="index">
              <van-image :src="seatImageListPath(key)" fit="contain" height="20"></van-image>
              <span>{{ areaMap.get(key).price }}</span>
            </div>
            <div class="seat_legend-item fx-center fx-row">
              <van-image :src="require('@/assets/images/seat/seat_couple.png')" fit="contain" height="20" />
              <span>情侣座</span>
            </div>
          </div>
          <div class="cinema_tips">
            <van-notice-bar text="为了疫情防控，观影需全程佩戴口罩，影厅内禁止饮食" :left-icon="require('@/assets/images/movie/tip.png')"
              :color="$config.style.secondColor" background="transparent"></van-notice-bar>
          </div>
        </div>
        <div class="seat_table-wrap" ref="seatTable">
          <ul v-if="rowNameArray && rowNameArray.length > 0" class="seat_row_name fx-center"
            :style="`transform: scale(${rate})`">
            <li v-for="item, index in rowNameArray" :key="index">{{ item }}</li>
          </ul>
          <div class="seat_map-wrap fx-row" ref="seatMapWrap">
            <div>
              <div class="seat_screen-wrap fx-column fx-center" :style="seatMapWidth">
                <span class="seat_screen"></span>
                <span class="seat_screen_name">{{ movie.roomname }}银幕</span>
              </div>
              <div v-if="Object.keys(seatMap).length > 0" class="seat_map"
                :style="`${seatMapWidth};transform: scale(${rate})`">
                <div v-for="rowItem in seatGrid.rowArray" :key="rowItem" class="seat-row">
                  <template v-for="columnItem in seatGrid.columnArray">
                    <span :key="columnItem" :class="filter_seat_class(seatMap[`${rowItem}:${columnItem}`])">
                      <div v-if="seatMap[`${rowItem}:${columnItem}`]"
                        @click="toggleSeat(seatMap[`${rowItem}:${columnItem}`])" class="h06-py-seat-item-click">
                        <van-image :src="seatMap[`${rowItem}:${columnItem}`] | filter_seat_image"
                          width="100%" height="100%" class="seat_img"></van-image>
                      </div>
                    </span>
                  </template>
                </div>
              </div>
            </div>
            <div class="block-width50"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-wrap">
      <div class="seat_selected-wrap">
        <div class="movie_name">{{ movie.moviename }}</div>
        <div class="movie_play_time">
          {{ $getCalendar(movie.playtime, 2) }}-{{ $momentFormatter(movie.closetime, "HH:mm")}}&nbsp;{{ movie.edition }}
        </div>
        <van-divider class="divider"></van-divider>
        <div class="seat_selected fx-row fx-center">
          <div class="seat_selected-item fx-row fx-center" v-for="item, index in selectedSeatList" :key="index">
            <div class="seat_info fx-middle">
              <span>{{ item.name }}</span>
              <span v-if="item.realPrice" class="fc-active">到手价{{ item.realPrice }}</span>
              <span v-else class="fc-active">到手价{{ movie.showPrice | formatIntToMoney }}</span>
            </div>
            <div class="seat_delete fx-column fx-middle" @click="deleteSeat(item)">
              <van-image :src="require('@/assets/images/movie/close_grey.png')" fit="cover" width="11"></van-image>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部确认选座按钮 -->
      <div class="seat_selected_confirm">
        <van-button v-if="selectedSeatList.length > 0" type="primary" :color="$config.style.primaryColor" block round
          @click="confirm_create_order_1" class="h06-py-seat-confirm">确认选座</van-button>

        <van-button v-else type="primary" :color="$config.style.primaryColor" block round
          @click="confirm_create_order_1"
          disabled>请先选座</van-button>
      </div>
    </div>

    <div class="utils-wrap">
      <van-overlay :show="showValidateSeatError" @click="showValidateSeatError = false" z-index="19">
        <div class="fx-center-middle" style="height: 100%;">
          <div class="error-wrap fx-column fx-around">
            <div class="fx-center">
              <van-image :src="require('@/assets/images/seat/notice.png')" height="30" fit="cover"></van-image>
            </div>
            <div class="fx-row fx-middle">
              <van-image :src="require('@/assets/images/seat/select_seat.png')" width="50" height="50"></van-image>
              <van-image :src="require('@/assets/images/seat/empty_seat.png')" width="50" height="50"></van-image>
              <van-image :src="require('@/assets/images/seat/select_seat.png')" width="50" height="50"></van-image>
            </div>
            <div class="fx-center">
              <span class="error-tips">座位旁边不要留空</span>
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import seatImageList from "./seat-image";
import { seatImagePathMap } from "./seat-image";
import { formatIntToMoney } from "@/libs/common-utils/common-utils";
import { mapActions, mapGetters } from "vuex";
import { Dialog } from "vant";

import Hammer from "hammerjs";

export default {
  data() {
    // 价格等信息没从本页请求的接口来 从上一页放到 cookie 的缓存来
    let movie = this.$cookies.get(this.$config.const.KEY_CURRENT_MOVIE)

    // 上一页给过来的分区价格信息似乎不准 下面请求场次信息后给
    // 这里给个初始值 避免模板渲染报错
    let { areaMap } = area_price_to_map([])

    return {
      movie,
      areaMap,
      seatImageList,
      maxRow: -1,
      maxColumn: -1,
      rowNameMap: new Map(),
      rowNameArray: [],
      seatInfo: null,
      columnTotal: 0,
      seatList: [],
      seatMap: {},
      coupleSeatMap: new Map(),
      activitiesPrice: null,
      showValidateSeatError: false,
      rate: 0.618,
      changeSeat: 0,
      movieRepeatCount: 0
    };
  },

  computed: {
    ...mapGetters([
      "selectedSeatList",
      "loginPhone",
      "txId"
    ]),

    seatGrid() {
      if (!this.seatInfo) return { rowArray: [], columnArray: [] };
      let rowArray = [];
      let columnArray = [];
      for (let i = this.seatInfo.minrow; i <= this.seatInfo.maxrow; i++) {
        rowArray.push(i);
      }
      for (let i = this.seatInfo.mincolumn; i <= this.seatInfo.maxcolumn; i++) {
        columnArray.push(i);
      }
      return { rowArray, columnArray };
    },

    seatMapWidth() {
      if (this.columnTotal) {
        return `width: ${this.columnTotal * 33 / this.$config.remUnit}rem;`;
      }
      return "width: 100%;";
    },

    selectedSeatOrderParams() {
      let seatIds = new Array();
      let seatNames = new Array();
      for (let item of this.selectedSeatList) {
        seatIds.push(item.seatid);
        seatNames.push(item.name);
      }
      return {
        seatIds: seatIds.join("|"),
        seatNames: encodeURI(seatNames).split(",").join("|")
      };
    },

    totalPrice() {
      let totalPrice = 0;
      let selectedSeatList = this.selectedSeatList;

      selectedSeatList.forEach((item) => {
        totalPrice += item.realPrice || formatIntToMoney(this.movie.showPrice);
      });
      return Number(totalPrice).toFixed(2);
    }
  },

  methods: {
    ...mapActions([
      "changeSelectedSeat",
      "initSelectedSeatMap"
    ]),

    filter_seat_class_0(seat) {
      if (!seat) return "";

      if (seat.flag == 1) {
        return "seat_item-couple-left";
      }

      if (seat.flag == 2) {
        return "seat_item-couple-right";
      }
      return "";
    },

    filter_seat_class(seat) {
      if (!seat) return "";

      let classes = [ this.filter_seat_class_0(seat) ]

      // 座位状态：可选/已售
      if (seat.status == 1) {
        classes.push("h06-py-seat-available");
      } else {
        classes.push("h06-py-seat-sold");
      }

      // 座位类型：普通座/情侣座
      if (seat.flag == 0) {
        classes.push("h06-py-seat-normal");
      } else {
        classes.push("h06-py-seat-couple");
      }

      return classes.join(" ");
    },

    // 远程请求所有座位信息
    getMovieCinemaSeat() {
      let movie = this.$cookies.get(this.$config.const.KEY_CURRENT_MOVIE)
      this.movie = movie

      let params = {
        opiid: this.movie.opiid
      };

      let loadingToast = this.$toast.loading(this.$config.loadingMsg);
      this.$service.getMovieCinemaSeat(params).then((res) => {
        if (res.data) {
          this.areaMap = area_price_to_map(res.data.opi.areaPrice_array).areaMap;

          budo_log.info("#215 getMovieCinemaSeat", JSON.stringify(res.data.opi.areaPrice), 
            JSON.stringify(this.movie.areaPrice), JSON.stringify(this.areaMap))

          // TODO 这里场次失效时 无法获取座位信息 返回的 res = {"success":true, "data":{}} 待处理
          this.buildSeatList(res.data.seatList);
          this.buildSeatInfo(res.data.opi);
          this.scrollToCenter();
        } else {
          this.$toast.fail({ message: "场次已关闭，请返回重试", duration: 30000 });
        }
        loadingToast.clear();
      }).catch(() => {
        loadingToast.clear();
      });
    },

    seatImageListPath(key) {
      var idx_y = parseInt(this.areaMap.get(key).index)
      var seat = this.seatImageList[0][idx_y]
      if (!seat) {
        budo_log.info("#208 seatImageListPath, seatImageList=", this.seatImageList, "areaMap=", this.areaMap, "key=", key, "idx_y=", idx_y)
        return null
      }

      return seat.path
    },

    confirm_create_order_1() {
      budo_log.info("#205 moviename: ", this.movie.moviename, "opiid: ", this.movie.opiid);

      this.$service.getMovieRepeat(this.movie.moviename, this.movie.opiid).then(res => {
        if (res.code === 0) {
          if (res.data > 0) {
            sessionStorage.setItem("RC_MOVIE_REPEAT_COUNT", res.data);
            this.$dialog.confirm({ message: "有其他场次未观看的电影，暂不支持兑换" });
          } else {
            this.changeSeat = 0;
            this.create_order_2(); // 创建订单 2
          }
        } else {
          this.$dialog.confirm({ message: "请求数据错误；" + res.msg + ";代码：0000232X" });
        }
      });
    },

    create_order_2() {
      let loadingToast = this.$toast.loading("正在验证...")

      // 检查座位
      this.valid_seat().then(res => {
        // 是否创建订单
        if(!res?.data?.create) {
          budo_log.info("#283 create_order_2 valid_seat no create", res)
          return
        }

        let params = this.$route.query.flag ? { flag: this.$route.query.flag } : {}
        budo_log.info("#288 create_order_2 valid_seat", res, params)

        // 创建订单
        this.create_order_3().then(() => {
          loadingToast.clear()
        })
      }).catch(() => {
        loadingToast.clear()
      })
    },

    cancelOrder(tradeno) {
      let loading = this.$toast.loading("释放座位中");

      this.$service.cancelMemberOrder({ tradeno }).then(() => {
        loading.clear();
        this.initPage();
      }).catch(() => {
        loading.clear();
        this.initPage();
      });
    },

    create_order_3() {
      return new Promise((resolve, reject) => {
        let params = {
          mobile: this.loginPhone,
          opiid: this.movie.opiid,
          seatids: this.selectedSeatOrderParams.seatIds,
          seatnames: this.selectedSeatOrderParams.seatNames,
          txid: this.txId,
          usearea: "Y",
          changeSeat: this.changeSeat
        }

        this.movie.sdid ? params.sdid = this.movie.sdid : void (0);
        this.$route.query.flag ? params.flag = this.$route.query.flag : void (0);

        budo_log.info("#300 createPartnerOrder, params", params);

        // 调接口
        this.$service.createPartnerOrder(params).then((res) => {
          budo_log.info("#305 createPartnerOrder res", res);

          if (res.error) {
            Dialog.confirm({ message: res.error || "创建订单失败 K" }).then(() => {
              if ( -666 == res.code ) {
                window.location.href = "/web/order-list" // 这个错误码就是有锁座订单 去订单列表关闭之
              }
            })
          } else {
            window.location.href = res.url // 电影订单这里跳转到 movie-order-create 创建订单并写 store
          }

          resolve();
        }).catch(({ errorCode, errorMsg }) => {
          budo_log.info("#269 catch", errorCode, errorMsg);
          reject();
        });
      });
    },

    // 校验所选座位是否允许
    valid_seat() {
      // 1.座位留空问题
      let validateMap = {}
      let validStr
      let seat

      return new Promise((resolve, reject) => {
        this.selectedSeatList.forEach((selectedSeatItem) => {
          for (let rowItem of this.seatGrid.rowArray) {
            if (selectedSeatItem.row == rowItem) {
              if (!validateMap[rowItem]) {
                validStr = ""
                for (let columnItem of this.seatGrid.columnArray) {
                  seat = this.seatMap[`${rowItem}:${columnItem}`]
                  if (!seat) {
                    validStr += "O"
                    continue
                  }
                  if (seat.isSelected) validStr += "B";
                  else validStr += (seat.status == 0 ? "S" : "A")
                }
                validateMap[rowItem] = validStr
              }
            }
          }
        })

        validStr = Object.values(validateMap).join("@")

        // 校验所选座位是否允许
        this.$service.validate_selected_seat_list({
          rowsseats: validStr
        }).then(res => {
          if (res?.data?.valid) {
            this.showValidateSeatError = false  // 成功
            resolve(res)
          } else {
            this.showValidateSeatError = true  // 失败 座位两边不要留空
            reject(res)
          }
        })
      })
    },

    // 点击选中座位列表中的关闭按钮 删除座位
    deleteSeat(seat) {
      seat.isSelected = false;
      if (seat.lovegroup) {
        // 删除的座位为情侣座时 相对应修改情侣座信息
        let oppositeSeat = this.coupleSeatMap.get(seat.lovegroup);
        if (oppositeSeat) {
          oppositeSeat.isSelected = false;
          this.changeSelectedSeat(oppositeSeat);
          this.updateSeatStatus(oppositeSeat);
        }
      }

      // 改变已选座位集合 + 更新座位状态
      this.changeSelectedSeat(seat);
      this.updateSeatStatus(seat);
      this.$forceUpdate();
    },

    // 切换选中座位
    toggleSeat(seat) {
      if (seat.status != 1) return;
      seat = Object.assign({}, seat);
      seat.isSelected = !!!seat.isSelected;
      let selectedLength = this.selectedSeatList.length;
      let maxCanBuy = this.seatInfo.maxcanbuy;
      let loveGroup = seat.lovegroup;
      selectedLength += seat.isSelected == false ? 0 : (loveGroup ? 2 : 1);
      if (seat.isSelected && selectedLength > maxCanBuy) {
        this.$toast(`最多可选${maxCanBuy}个座位`);
        return;
      }
      if (loveGroup) {
        let oppositeSeat = this.coupleSeatMap.get(loveGroup);
        if (oppositeSeat) {
          oppositeSeat.isSelected = seat.isSelected;
          this.changeSelectedSeat(oppositeSeat);
          this.updateSeatStatus(oppositeSeat);
        }
      }
      // 改变已选座位集合 + 更新座位状态
      this.changeSelectedSeat(seat);
      this.updateSeatStatus(seat);
      this.$forceUpdate();
    },

    // 根据座位集合构建情侣座Map 以及以座位行列为Key的seatMap对象 用于快速取出座位对象 (一次循环包括以下几个操作)
    buildSeatList(seatList) {
      let rowNameMap = new Map();
      let seatMap = {};
      // let startTime = new Date().getTime();
      budo_log.info("#438 this.areaMap", this.areaMap);

      seatList.forEach((item, index) => {
        // 1.座位下标赋值给座位的属性中 用于之后的快速更新座位信息 isSelected  this.$set(originArray, index, targetObject);
        item.seatIndex = index;
        if (this.areaMap.size > 0) {
          // 2.构建不同区域的座位价格
          let areaInfo = this.areaMap.get(item.area);
          areaInfo?.price ? item.realPrice = Number(areaInfo.price) : "";
          areaInfo ? item.areaPic = seatImageList[parseInt(item.flag)][areaInfo.index] : "";
          // item.realPrice = Number(areaInfo.price);
          // item.areaPic = seatImageList[parseInt(item.flag)][areaInfo.index];
        }

        // 3.根据座位的行列 row:column 将座位信息保存在seatMap的Object中 例如{'3:2': {座位对象}, '3:3': {座位对象}}
        // 使用Vue的$set方法使他变为响应式数据
        this.$set(seatMap, `${item.row}:${item.column}`, item);
        if (item.lovegroup) {
          // 4.当该座为情侣座时 赋值相对应的座位为自己 用于取情侣座 例如: 该座=1L, 则coupleSeatMap.set('1R', 该座);
          let loveGroup = item.lovegroup;
          let position = loveGroup.split("")[loveGroup.length - 1];
          let oppositePosition = position == "R" ? "L" : position == "L" ? "R" : "";
          let oppositeKey = "" + parseInt(loveGroup) + oppositePosition;
          this.coupleSeatMap.set(oppositeKey, item);
        }

        // 5.将所有的行信息 rowname 保存在行的Map数据中
        if (!rowNameMap.has(parseInt(item.row))) {
          rowNameMap.set(item.row, item.rowname);
        }
      });

      // 数据示例: [{0 => 1}, {1 => 2}, {2 => 4}] 代表row = 0, 行标为1 | row = 1, 行标为2 | row = 2, 行标为4,(中间可能空一行座位为过道)
      this.rowNameMap = rowNameMap;
      this.seatList = seatList;
      this.seatMap = seatMap;
      // budo_log.info(`#473 构建时长 -> ${new Date().getTime() - startTime}毫秒`);
      // budo_log.info("#474",this.rowNameMap);
    },

    buildSeatInfo(seatInfo) {
      this.columnTotal = seatInfo.maxcolumn - seatInfo.mincolumn + 1; //用于计算seat-map的宽度
      let rowNameArray = []; //座位行标
      for (let row = seatInfo.minrow; row <= seatInfo.maxrow; row++) {
        let rowName = this.rowNameMap.get(row);
        rowNameArray.push(rowName ? rowName : "");
      }
      this.rowNameArray = rowNameArray;
      this.seatInfo = seatInfo;
      // budo_log.info("#485", rowNameArray);
    },

    // 前端更新座位状态(包括源座位集合seatList, 以及用于渲染座位图的 seatMap)
    updateSeatStatus(seat) {
      let seatKey = `${seat.row}:${seat.column}`;
      this.$set(this.seatList, seat.seatIndex, seat);
      this.$set(this.seatMap, seatKey, seat);
    },

    // 移动到座位中心图
    scrollToCenter() {
      this.$nextTick(() => {
        let seatMapWrap = this.$refs.seatMapWrap || {};
        seatMapWrap.scrollLeft = seatMapWrap?.offsetWidth * 0.5;
      });
    },

    initPage() {
      this.initSelectedSeatMap();
      if (this.$route.query.cinemaName) {
        this.$documentTitle(this.$route.query.cinemaName);
      }
      this.getMovieCinemaSeat();
    },

    listenSeatMapPinch() {
      let hammer = new Hammer(this.$refs.seatTable);
      let _this = this;
      hammer.get("pinch").set({ enable: true });
      hammer.on("pinchin", function (e) {
        if (_this.rate > 0.618) {
          _this.rate -= 0.1;
        }
      });

      hammer.on("pinchout", function (e) {
        if (_this.rate < 1) {
          _this.rate += 0.1;
        } else {
          budo_log.info("#477 最大了 hammer on pinchout");
        }
      });
    }
  },

  mounted() {
    // 初始化已选座位对象
    this.initPage();

    if (sessionStorage.getItem("RC_MOVIE_REPEAT_COUNT")) {
      this.movieRepeatCount = +sessionStorage.getItem("RC_MOVIE_REPEAT_COUNT");
    }
  },

  filters: {
    // getSeatImage filter_seat_image
    filter_seat_image(seat) {
      if (!seat) return "";
      // 如果该座位为标记的区域座位 直接返回座位的图片
      if (seat.areaPic && !seat.isSelected && seat.status == 1) {
        return seat.areaPic.path
      }

      let seatImageKey = `${seat.status}:${seat.flag}`;
      seatImageKey += seat.isSelected ? ":1" : "";
      let seatImage = seatImagePathMap.get(seatImageKey);
      return seatImage ? seatImage.path : "";
    }
  }
};

/**
 * 输入参数为 [{
 *    "area":"7105",
 *    "showPrice":37,
 *    "settlePrice":34.1,
 *    "serviceFee":3
 *  },{
 *    "area":"7104",
 *    "showPrice":27,
 *    "settlePrice":25.1,
 *     "serviceFee":3
 *  }]
 * @param {转换源字符串} str
 */
function area_price_to_map(str) {
  budo_log.debug("#550 area_price_to_map", JSON.stringify(str))

  let areaMap = new Map();
  if (str) {
    str.forEach((item, index) => {
      areaMap.set(item.area, { index, price: item.showPrice });
    });
  }
  return { areaMap };
}
</script>

<style lang="scss" scoped>
.body-wrap {
  position: relative;

  .fill-box {
    @include scroll-bar-none();
  }

  .seat_legend-wrap {
    width: 100%;
    position: fixed;
    z-index: 6;

    .seat_legend {
      padding: 8px 0;
      width: 100%;
      background-color: #fff;
      overflow: scroll;

      .seat_legend-item {
        white-space: nowrap;
        margin: 0 3px;

        .van-image {
          border-radius: 4px;
          overflow: hidden;
        }

        >* {
          margin: 0 1px;
        }

        span {
          font-size: 12px;
        }
      }
    }

    .cinema_tips {
      width: 100%;
      padding: 0 15px;
      background-color: #fff;

      /deep/ .van-notice-bar {
        font-size: 12px;
        padding: 0px;
        line-height: 25px;
        height: 25px;
      }
    }
  }

  .seat_table-wrap {
    position: relative;
    padding-top: 80px;

    .seat_row_name {
      position: absolute;
      width: 18px;
      padding: 15px 0;
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 9px;
      z-index: 5;
      left: 10px;
      top: calc(80px + 50px + 40px - 15px); // = seat-table的padding-top:80 + seat-map的margin-top: 50px + seat-screen-wrap的height:40px - 自身的padding: 15px 0;

      li {
        width: 18px;
        height: 30px;
        line-height: 25px;
        text-align: center;
        color: #fff;
      }

      li:nth-last-child(1) {
        height: 25px;
      }
    }

    .seat_map-wrap {
      width: 100%;
      overflow: scroll;
      background-color: $bg-light-color;
      @include scroll-bar-none();

      .seat_screen-wrap {
        height: 40px;
        margin-left: 50px;

        .seat_screen {
          display: inline-block;
          background-color: #f90040;
          height: 5px;
          width: 100px;
          margin: 4px 0;
        }

        .seat_screen_name {
          color: $tips-color;
        }
      }

      .seat_map {
        position: relative;
        margin: 50px;
        margin-bottom: 300px;

        .seat-row {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          margin-top: 5px;

          span {
            display: inline-block;
            width: 33px;
            height: 25px;
            padding: 0 3px;
            font-size: 9px;
            overflow: hidden;

            >div {
              height: 100%;
              width: 100%;
              background-color: #fff;
              border-radius: 4px;
              overflow: hidden;
            }
          }

          span.seat_item-couple-left {
            width: calc(33px + 3px);
            padding-right: 0px;

            >div {
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
            }
          }

          span.seat_item-couple-right {
            width: calc(33px + 3px);
            padding-left: 0px;

            >div {
              border-top-left-radius: 0px;
              border-bottom-left-radius: 0px;
            }
          }
        }
      }

      .seat_map:before,
      .seat_map:after {
        content: "";
        position: absolute;
        border-style: dotted;
        border-color: #e42f46;
        border-width: 0;
        z-index: 2;
        pointer-events: none;
      }

      .seat_map:before {
        width: 0;
        height: 100%;
        border-left-width: 1px;
        left: 50%;
        top: 0;
      }

      .seat_map:after {
        width: 100%;
        height: 0;
        border-top-width: 1px;
        top: 50%;
        left: 0;
      }
    }
  }
}

.footer-wrap {
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 0 12px;

  >div {
    margin-bottom: 12px;
    border-radius: 4px;
  }

  >div:not(:nth-last-child(1)) {
    padding: 5px 12px;
    background-color: #fff;
  }

  .seat_selected-wrap {
    .movie_name {
      font-size: 18px;
      // font-family: "pf medium";
      padding: 5px 0;
    }

    .seat_selected {
      overflow-x: scroll;
      width: 100%;
      @include scroll-bar-none();

      .seat_selected-item {
        word-break: keep-all;
        white-space: nowrap;
        background: $bg-color;
        border-radius: 4px;
        padding: 4px 0;

        .seat_info {
          padding: 0 10px;

          >span {
            display: inline-block;
            padding: 1px 0;
          }
        }

        .seat_delete {
          padding: 0 10px;
          height: 20px;
          border-left: 2px solid $border-color;
        }
      }

      .seat_selected-item:not(:nth-last-child(1)) {
        margin-right: 5px;
      }
    }

    .divider {
      margin: 8px 0;
    }
  }
}

.utils-wrap {
  /deep/ .error-wrap {
    height: 28%;
    width: 70%;
    background: rgba(0, 0, 0, 0.5);

    .error-tips {
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
